import Stack from '@mui/material/Stack';
import JumboAppTextField from '@jumbo/components/JumboAppTextField';
import LoadingButton from '@mui/lab/LoadingButton';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { CircularProgress } from '@mui/material';

const AddRole = ({ value, onClose, handleSubmit }) => {
  const validationSchema = Yup.object({
    role: Yup.string().required('Please enter role'),
    description: Yup.string().required('Please enter description'),
  });

  return (
    <>
      <Formik
        initialValues={{
          role: value?.name || '',
          description: value?.description || '',
        }}
        validationSchema={validationSchema}
        onSubmit={(data, { setSubmitting }) => {
          setSubmitting(true);
          setTimeout(() => {
            handleSubmit(data);
            setSubmitting(false);
          }, 1500);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <JumboAppTextField
              sx={{ mb: 2, mt: 1 }}
              fullWidth
              name="role"
              label="Role*"
            />
            <JumboAppTextField
              sx={{ mb: 4 }}
              fullWidth
              name="description"
              label="Description*"
            />
            <Stack
              spacing={{ xs: 1, sm: 2 }}
              direction="row"
              justifyContent="flex-end"
            >
              <LoadingButton
                variant="outlined"
                color="secondary"
                onClick={onClose}
                size="large"
                // sx={{ mb: 3 }}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                type="submit"
                variant="contained"
                size="large"
                sx={{ mb: 3 }}
                loading={isSubmitting}
                loadingIndicator={<CircularProgress size={20} />}
              >
                Save
              </LoadingButton>
            </Stack>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddRole;
